import React, { useState } from 'react';
import '@/pages/dashboard/assets/scss/page/competitor/keyMetrics.scss';
import {
  Col,
  Row,
} from 'tea-component';
// import Filter from '@/pages/dashboard/filterPageComponents/competitor/keyMetricsFilter';
import Filter from '@/pages/dashboard/filterPageComponents/competitor/KeyMetricsFilterNew';
import { useLocal } from '@/pages/dashboard/utils/customHook';
import { useBuriedPoint } from "@/pages/home/utils/customHook";

import KeyMetricsTrend from './KeyMetricsTrend';
import { connect } from 'umi';
import KeyMetricsTable from "@/pages/dashboard/pages/competitor/KeyMetrics/KeyMetricsTable";
import MarqueeInfo from "@/pages/dashboard/components/MarqueeInfo";

function KeyMetrics(props: any) {
  const { 
    gameCode,
    dataFrame,
    explainInfo, 
    competitorReqType,
    urlReqType,
    isCasual = false,
  } = props;
  
  const { getLocalText } = useLocal();
  const [filterValue, setFilterValue] = useState(null);
  const [filterLoading, setFilterLoading] = useState(true);
  const handleInit = (filterValue: any) => {
    setFilterValue(filterValue);
    setFilterLoading(false);
  };

  const handleFilterSave = (filterValue: any) => {
    setFilterValue(filterValue);
  };
  // 打点信息
  const logObj = {
    pageId: competitorReqType === 'xh' ? '204001' : '201301',
    pageName: competitorReqType === 'xh' ? 'competitorKeyMetricsXh' : 'competitorKeyMetrics',
    extInfo: competitorReqType === 'xh' ? 'competitorKeyMetricsXh' : 'competitorKeyMetrics',
    pagePath: `/competitor/${urlReqType}/keyMetrics`,
    uid: gameCode,
    typeId: 'dashboard_pc_v2',
  };
  useBuriedPoint(logObj);

  return (
    <div className="dbd-key-metrics">
      <MarqueeInfo pagePath={logObj.pagePath}/>
      <Filter
        openSticky={true}
        filterConfirm={handleFilterSave}
        filterReset={handleFilterSave}
        filterInit={handleInit}
        competitorReqType={competitorReqType}
        urlReqType={urlReqType}
        buttonLogConfig={{ pageId: logObj.pageId, confirmButtonId: `${logObj.pageId  }001`, resetButtonId: `${logObj.pageId  }002` }}
      />
      <div className="dbd-key-metrics-title">{getLocalText('competitor_key_metrics_trend_title')}</div>
      <Row className="dbd-key-metrics-main-row">
        <KeyMetricsTrend
          filterValue={filterValue}
          filterLoading={filterLoading}
          gameCode={gameCode}
          competitorReqType={competitorReqType}
          isCasual={isCasual}
        />

        <Col>
          <KeyMetricsTable
            gameCode={gameCode}
            dataFrame={dataFrame}
            explainInfo={explainInfo}
            filterLoading={filterLoading}
            filterValue={filterValue}
            competitorReqType={competitorReqType}
            isCasual={isCasual}
          />
        </Col>

      </Row>
    </div>
  );
}

export default connect((state: any) => {
  return {
    serviceData: state.overview?.data,
    gameCode: state.dashboard?.currentGame?.game_code,
    dataFrame: state.dashboard?.currentGame?.data_frame || '',
    explainInfo: state.dashboard?.explainInfo,
  };
})(KeyMetrics);
